import { API_URL_PARTNER } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getItems = () =>
  apiInstance({
    url: API_URL_PARTNER,
    params: {
      limit: 5000,
      sort: "order",
      order: 1,
    },
  });

export default getItems;
